export interface PartialPaymentPrices {
  partial_payment: number;
  partial_payment_contract_version: number;
  partial_payment_coupon_amount: number;
  partial_payment_coupon_applied_amount: number;
}

export function getPartialPaymentPrices(
  prices: any
): PartialPaymentPrices | null {
  if (
    !prices ||
    prices.partial_payment_contract_version !== 1 ||
    ![
      prices.partial_payment,
      prices.partial_payment_coupon_amount,
      prices.partial_payment_coupon_applied_amount,
    ].every(
      (amount) =>
        typeof amount === "number" && Number.isFinite(amount) && amount >= 0
    )
  ) {
    return null;
  }

  return {
    partial_payment: prices.partial_payment,
    partial_payment_contract_version: 1,
    partial_payment_coupon_amount: prices.partial_payment_coupon_amount,
    partial_payment_coupon_applied_amount:
      prices.partial_payment_coupon_applied_amount,
  };
}
